import AuthDialogLayout from "components/Layout/AuthDialogLayout";
import { auth } from "../../firebase/authService";
import useAuth from "hooks/useAuth";
import useDialog from "hooks/useDialog";
import React, { useEffect, useState } from "react";
import { isObjectEmpty } from "utils/commonUtils";

const VerifyEmailDialog = () => {
  const {
    isVerifyEmailDialogOpen,
    closeVerifyEmailDialog,
    verifyEmailDialogData,
    openSignupDialog,
    openTrialWelcomeDialog,
  } = useDialog();
  const { error, loading, deleteUserAccount, fetchUserData } = useAuth();
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [errorEmailVerified, setErrorEmailVerified] = useState(false);

  useEffect(() => {
    // Check if verifyEmailDialogData has value
    if (!isObjectEmpty(verifyEmailDialogData)) {
      setEmail(verifyEmailDialogData?.email);
      setUserName(
        `${verifyEmailDialogData?.firstName} ${verifyEmailDialogData?.lastName}`
      );
    }
  }, [verifyEmailDialogData]);

  const handleContinue = async (e) => {
    e.preventDefault();

    await auth.currentUser.reload();
    if (auth?.currentUser?.emailVerified) {
      await fetchUserData(auth.currentUser);
      closeVerifyEmailDialog();
      // Show trial popup for new users
      openTrialWelcomeDialog();
    } else {
      setErrorEmailVerified(true);
      setTimeout(() => {
        setErrorEmailVerified(false);
      }, 200);
    }
  };

  const handleRetry = async () => {
    await deleteUserAccount();
    closeVerifyEmailDialog();
    openSignupDialog();
  };

  return (
    <AuthDialogLayout
      isDialogOpen={isVerifyEmailDialogOpen}
      closeDialog={closeVerifyEmailDialog}
    >
      <form onSubmit={handleContinue} className="mt-[166px]">
        <h2 className="text-[20px] font-semibold leading-[28px] text-[#1A1A1A]">
          Benvenuto {userName}
        </h2>
        <p
          className={`text-[15px] font-normal leading-[18.15px] text-[#1A1A1A] mt-[24px] ${
            errorEmailVerified ? "error-shake" : ""
          } `}
        >
          Clicca sul link che ti abbiamo inviato via email per verificare il tuo
          account. Se non trovi l'email, controlla la cartella spam.
        </p>
        <div className="mt-[24px]">
          <label className="text-[11px] font-normal text-[#333333] pl-4">
            Email
          </label>
          <input
            readOnly
            onClick={(e) => setEmail(e.target.value)}
            value={email}
            placeholder="Email"
            className="auth-input"
          />
        </div>

        {error && (
          <div className="mt-[24px] ">
            <p className="text-[#F61D1D] text-center text-[15px] font-normal line-clamp-2">
              {error}
            </p>
          </div>
        )}

        <button
          disabled={loading || errorEmailVerified}
          className="bg-primary disabled:cursor-not-allowed rounded-[6px] hover:bg-opacity-80 transition-all duration-300 ease-in-out h-[40px] w-full text-center text-[15px] font-bold leading-5 tracking-[0.3px] text-white my-[32px]"
        >
          Continua
        </button>
        <div className="flex items-center space-x-2 justify-center">
          <p className="text-[12px] font-normal leading-5 tracking-[0.3px] text-[#1A1A1A]">
            Hai inserito una mail errata?{" "}
          </p>
          <p
            onClick={handleRetry}
            className="cursor-pointer text-[12px] font-normal leading-5 tracking-[0.3px] text-primary"
          >
            Riprova
          </p>
        </div>
      </form>
    </AuthDialogLayout>
  );
};

export default VerifyEmailDialog;
